import axios from 'axios'
import config from '@/config'

const BPService = {
  async getProfile() {
    try {
      let res = await axios({
        method: 'GET',
        url: config.BASE_URL + '/business/profile/all',
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async getBenefits(lang) {
    try {
      let res = await axios({
        method: 'GET',
        url: config.BASE_URL + `/business/profile/benfit/link/en/list`,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async createProfile(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/create`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async sendEmail(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/candidate/email`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async updateProfile(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/update`,
        data: data,
      })
      return res.data
    } catch (e) {
      console.log('e: ', e.response)
      throw e.response.data
    }
  },

  async createBenefit(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/benefits/create`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async updateBenefit(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/benefits/update`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async updateTeam(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/team/update`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async KPICreate(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/kpi/create`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async KPIUpdate(data) {
    try {
      let res = await axios({
        method: 'POST',
        url: config.BASE_URL + `/business/profile/kpi/update`,
        data: data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async createSocials(data) {
    try {
      const res = await axios({
        method: 'POST',
        url: `${config.BASE_URL}/business/profile/social/create`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async updateSocials(data) {
    try {
      const res = await axios({
        method: 'POST',
        url: `${config.BASE_URL}/business/profile/social/update`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async uploadInsideMedia(data) {
    try {
      const res = await axios({
        method: 'POST',
        url: `${config.BASE_URL}/business/profile/inside/create?slNo=${data.slNo}&published=true`,
        data: data.formData,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async deleteInsideMedia(data) {
    try {
      const res = await axios({
        method: 'POST',
        url: `${config.BASE_URL}/business/profile/inside/update?slNo=${data.slNo}&published=true&deleteInside=true&insideId=${data._id.$oid}`,
        data,
      })
      return res.data
    } catch (e) {
      throw e.response
    }
  },

  async getPublicProfile(data) {
    try {
      const res = await axios({
        method: 'GET',
        url: `${config.BASE_URL}/v1/profile/candidate/business/profile?companyId=${data.companyId}${
          data.noAuth ? '&noauth=true' : ''
        }`,
      })
      return res.data[0]
    } catch (e) {
      throw e.response
    }
  },
}

export default BPService
